import React, { Component } from 'react';
import { Switch, Redirect } from 'react-router-dom';

import GuardianRoute from '../../shared/GuardianRoute';
import AutofacturacionFiles from './files/AutofacturacionFiles';
import TimbradoTicket from './tickets/components/TimbradoTicket';
import AutofacturacionUpload from './files/AutofacturacionUpload';
import AutofacturacionTickets from './tickets/AutofacturacionTickets';
import AutofacturacionTicketInfo from './tickets/AutofacturacionTicketInfo';

class Autofacturacion extends Component {
  render() {
    return (
      <Switch>
        <Redirect
          from="/modulos/autofacturacion"
          to="/modulos/autofacturacion/archivos"
          exact
        />
        <GuardianRoute
          path="/modulos/autofacturacion/archivos"
          component={AutofacturacionFiles}
          can="autofacturacion.listar.archivos"
          exact
        />

        <GuardianRoute
          path="/modulos/autofacturacion/archivos/upload"
          component={AutofacturacionUpload}
          can="autofacturacion.subir.archivo"
          exact
        />

        <GuardianRoute
          path="/modulos/autofacturacion/tickets"
          component={AutofacturacionTickets}
          can="autofacturacion.listar.tickets"
          exact
        />
        <GuardianRoute
          path="/modulos/autofacturacion/tickets/:id/info"
          component={AutofacturacionTicketInfo}
          can="autofacturacion.info.tickets"
          exact
        />
        <GuardianRoute
          path="/modulos/autofacturacion/tickets/:id/facturar"
          component={TimbradoTicket}
          can="autofacturacion.info.tickets"
          exact
        />
      </Switch>
    );
  }
}

export default Autofacturacion;
